import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles(({ palette, colors, breakpoints }: Theme) => createStyles({
  container: {
    position: 'absolute',
    left: 0,
    right: 0,
    justifyContent: 'center',
    paddingLeft: 10,
    paddingRight: 10,
    background: '#F1F2F5',
  },
  content: {
    maxWidth: '1280px',
    width: '100%',
    flexGrow: 1,
  },

  table: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
  },

  tableItem: {
    borderRight: '1px solid #DCDEE5',
    borderBottom: '1px solid #DCDEE5',

    '&:nth-child(-n+4)': {
      borderTop: '1px solid #DCDEE5',
    },

    '&:first-child, &:nth-child(4n+1)': {
      borderLeft: '1px solid #DCDEE5',
    },

    [breakpoints.down('sm')]: {
      borderRight: '1px solid #DCDEE5',
      borderBottom: '1px solid #DCDEE5',

      '&:nth-child(-n+4), &:first-child, &:nth-child(4n+1)': {
        borderTop: 'none',
        borderLeft: 'none',
      },

      '&:first-child': {
        borderTop: '1px solid #DCDEE5',
      },
    },
  },
  tableMobileFirstColumnItem: {
    borderLeft: '1px solid #DCDEE5',
    '&:nth-child(-n+4), &:first-child, &:nth-child(4n+1)': {
      borderLeft: '1px solid #DCDEE5',
    },
  },
  tableFirstTitleColumnItem: {
    '& div': {
      justifyContent: 'left',
    },
  },
  tableMobileSMItem: {
    [breakpoints.down(380)]: {
      height: 90,
    },
  },
  tableMobileXSItem: {
    [breakpoints.down(325)]: {
      height: 90,
    },
  },
  defaultColumn: {
    height: '100%',
    padding: '16px 24px',
    background: '#F9FAFB',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  defaultColumnInfo: {
    justifyContent: 'space-between',
  },
  defaultColumnTitle: {
    background: '#FFF',
    fontSize: 22,
    fontWeight: 700,
    fontFamily: '"Montserrat", "Regular"',
  },
  defaultColumnText: {
    textAlign: 'left',
  },
  icon: {
    color: colors.icon,
    fontSize: '1rem',
    verticalAlign: 'middle',
  },
  checkIcon: {
    color: '#515B6A',
    fontSize: '1rem',
    verticalAlign: 'middle',
  },
  buttonPurchaseContained: {
    color: '#FFF',
    background: palette.buttonSingle.color,
    '&:hover': {
      backgroundColor: palette.buttonSingle.color,
    },
  },
  buttonPurchaseOutlined: {
    color: palette.buttonSingle.color,
    borderColor: palette.buttonSingle.color,
  },
  buttonLink: {
    '&:hover': {
      textDecoration: 'none',
    },
  },
  button: {
    height: '36px',
    maxWidth: '190px',
    width: '100%',
    whiteSpace: 'nowrap',
    textTransform: 'none',
    fontSize: 14,
    fontFamily: 'Montserrat, sans',
    fontWeight: 600,
    padding: '5px 20px',
    boxShadow: 'none',
    letterSpacing: '0.21px',
  },
  buttonLabel: {
    padding: 'none',
    fontSize: 14,
  },

  mobileContainer: {

  },
  mobileItem: {

  },
  comment: {
    fontSize: '12px',
    padding: '0 10px 0 10px',
  },
  commentButtonWrapper: {
    width: '48px',
    textAlign: 'center',
  },
}), { name: 'Pricing' });

export default useStyles;
